<template>
  <section class="pb-[60px] xl:pb-[140px]">
    <div class="container">
      <SectionTitle :title="$t('landing.faq.title')" />
      <div
        v-for="(faq, idx) in faqList"
        :key="idx"
        class="group transition-300 rounded-3xl"
        :class="selectedItem === faq.id ? '!bg-[#FAFAFA]' : 'bg-transparent'"
      >
        <div
          class="flex items-center justify-start cursor-pointer py-3 md:py-5 md:px-5 transition-300 rounded-3xl hover:bg-[#FAFAFA]"
          :class="
            selectedItem === faq.id ? 'border-grey-300' : 'border-transparent'
          "
          @click="openItem(faq.id)"
        >
          <div class="bg-white-300 p-1 border border-transparent mr-1">
            <svg
              class="transition-300"
              :class="{ 'rotate-180': selectedItem === faq.id }"
              width="24"
              height="24"
              viewBox="0 0 24 24"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                :class="{ 'stroke-green': selectedItem === faq.id }"
                class="group-hover:stroke-green transition-300"
                d="M4.07992 8.90997L10.5999 15.43C11.3699 16.2 12.6299 16.2 13.3999 15.43L19.9199 8.90997"
                stroke="#A2ABBE"
                stroke-width="1.5"
                stroke-miterlimit="10"
                stroke-linecap="round"
                stroke-linejoin="round"
              />
            </svg>
          </div>
          <h3
            :class="{ 'text-green': selectedItem === faq.id }"
            class="font-semibold text-base md:text-xl leading-140 text-dark transition-300 group-hover:text-green"
          >
            {{ $t(faq?.question) }}
          </h3>
        </div>

        <CollapseTransition>
          <div v-if="selectedItem === faq.id" class="md:p-5 max-md:pb-3 !pt-0">
            <p
              class="font-normal leading-148 text-sm md:text-base text-dark pl-10"
              v-html="$t(faq?.answer)"
            ></p>
          </div>
        </CollapseTransition>
      </div>
    </div>
  </section>
</template>

<script setup lang="ts">
import CollapseTransition from "@ivanv/vue-collapse-transition/src/CollapseTransition.vue";
import { ref } from "vue";
import { faqList } from "@/data/index";
import SectionTitle from "@/modules/Landing/components/Common/SectionTitle.vue";

const selectedItem = ref(0);

const openItem = (id: number) => {
  if (selectedItem.value === id) {
    selectedItem.value = 0;
    return;
  }
  selectedItem.value = id;
};
</script>

<style scoped></style>
